import React, { useEffect, useState } from "react";
import { Control, Controller, FieldErrors, useWatch } from "react-hook-form";
import { FormType } from "./../CreateForm";
import DateInput from "../../global/DateInput";
import ValidateError from "../../global/ValidateError";
import MultipleDate from "../../global/MultipleDate";
import RadioInput from "../../global/RadioInput";
import { useGetAllCourtsByNameQuery } from "../../../lib/redux/services/sections/Courts";
import SearchableSelect from "../../global/SearchableSelect";
import { useSelector } from "react-redux";
import { UserSliceType } from "../../../lib/redux/slices/userSlice";
import { useGetDictionary } from "../../../hooks/useGetDictionary";
import { daysOptions3 } from "../../../data/options";
import SelectOption from "../../global/SelectOption";
import { DictionaryType } from "../../../types";
import Select from "react-select";
import { selectStyle, selectTheme } from "../../../styles/selectStyles";

import Toggle from "../../global/Toggle";
import { useParams } from "react-router-dom";
import { cn, getFormatedDate } from "../../../utils/utils";
import { ExactDurationStepper } from "../../global/Counter";
import Input from "../../global/Input";
type Props = {
  type: "leagues" | "tournaments";
  control: Control<FormType, any> | any;
  errors: FieldErrors<FormType>;
  getValue: any;
  isAllow: boolean;
  register: any;
  setValue: any;
  selectedCourts: any;
  trigger: any;
  setAvailableCourtsLoading: any;
  setAvailableCourts: any;
  setSelectedCourts: any;
  setCourts: any;
  eventType: "new" | "edit" | "duplicate" | "view";
};
const slotsOption = [
  { value: 30, label: "30 Min" },
  { value: 60, label: "60 Min" },
  { value: 90, label: "90 Min" },
  { value: 120, label: "120 Min" },
  { value: 150, label: "150 Min" },
];
function ScheduleInfoV2({
  type,
  control,
  errors,
  register,
  setValue,
  trigger,
  setAvailableCourts,
  setAvailableCourtsLoading,
  getValue,
  setCourts,
  isAllow,
  setSelectedCourts,
  selectedCourts,
  eventType,
}: Props) {
  console.log(isAllow);

  
  const { inputs, leagues_tournaments, placeHolders, options }: DictionaryType =
    useGetDictionary();
  const [availableCourtsParam, setAvailableCourtsParam] = useState<any>({});
  const [skipFetch, setSkipFetch] = useState<boolean>(true);
  const param = useParams();
  const selectedClub = useSelector(
    (state: UserSliceType) => state.user.selectedClub
  );
  const startDate = useWatch({ control, name: "start_date" });
  const endDate = useWatch({ control, name: "end_date" });
  const matchDuration = useWatch({ control, name: "match_duration" });

  return (
    <div className="flex flex-col gap-4 w-full bg-white rounded-2xl p-4">
      <h3 className="font-bold text-[24px] text-primary dark:text-white ">
        Scheduling
      </h3>
      <div className="flex flex-col w-full gap-8">
       
        <div className="flex items-end w-full gap-4 mobile:flex-wrap">
          
          <div className="w-full flex-1 mobile:min-w-[200px]">
            <label className="block text-sm mb-2 font-bold">
              {inputs.allowed_courts}
              <span className="text-red-500">*</span>
            </label>
            <SearchableSelect
              control={control}
              errors={errors}
              setValue={setValue}
              trigger={trigger}
              name="court_ids"
              isfixedRootValue={true}
              fixedRootValue={selectedClub}
              fetchFunction={useGetAllCourtsByNameQuery}
              isRequired={true}
              isDisabled={!isAllow}
            />
            {errors.court_ids && <ValidateError />}
          </div>
          <div className="flex-1 w-full">
             <Controller
              name="match_duration"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                 <ExactDurationStepper
             onChange={(value) => field.onChange(value)}
             size="lg"
             value={field.value}
             />
              )}/>
          </div>
           
         
        
        </div>
        <div className='grid grid-cols-3 gap-[20px]'>
              
          <div className="w-full  mobile:min-w-[200px]">
              <Controller
                name="end_date"
                rules={{ required: true }}
                control={control}
                render={({ field }) => (
                  <DateInput
                    placeHolder={placeHolders.end_date}
                    isDisabled={!isAllow}
                    min={getFormatedDate(startDate)}
                    dateInputProps={{ ...field }}
                    name="end_date"
                    title={
                      inputs.end_date
                    }
                    //@ts-ignore
                    handleChangeEvent={(e) => {
                      // setSelectedCourts({});
                      setValue("end_date", e.replace("Sept", "Sep"));
                      setValue("excluded_days", []);
                      setValue("available_courts", []);
                      setValue("available_courts_ids", []);
                      // setAvailableCourtsParam({});
                      // setAvailableCourts([]);
                      trigger("end_date");
                    }}
                    customLabelClass="font-bold"
                  />
                )}
              />

              {errors.end_date && errors.end_date.type === "required" && (
                <ValidateError />
              )}
            </div>
            <div className="w-full ">
                <Controller
                  control={control}
                  name={`start_time`}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <Input
                      customClass={`${
                        (!isAllow || eventType == "view") &&
                        "bg-[#f3f3f3] cursor-not-allowed"
                      }`}
                      labelStyle="font-bold"
                      inputProps={{
                        ...field,
                        type: "time",
                        placeholder: "Start time",
                        readOnly: !isAllow,
                        disabled: !isAllow,
                        onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                          setValue("start_time", e.target.value);
                          setValue("available_courts", []);
                          setValue("available_courts_ids", []);
                          // setAvailableCourtsParam({});
                          // setAvailableCourts([]);
                        },
                      }}
                      label={inputs.start_time}
                    />
                  )}
                />
                {errors.start_time && errors.start_time.type === "required" && (
                  <ValidateError />
                )}
              </div>
              <div className="w-full ">
                <Controller
                  control={control}
                  name={`end_time`}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <Input
                      customClass={`${
                        (!isAllow || eventType == "view") &&
                        "bg-[#f3f3f3] cursor-not-allowed"
                      }`}
                      labelStyle="font-bold"
                      inputProps={{
                        ...field,
                        type: "time",
                        placeholder: "End time",
                        readOnly: !isAllow,
                        disabled: !isAllow,
                        onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                          setValue("end_time", e.target.value);
                          setValue("available_courts", []);
                          setValue("available_courts_ids", []);
                          // setAvailableCourtsParam({});
                          // setAvailableCourts([]);
                        },
                      }}
                      label={inputs.end_time}
                    />
                  )}
                />
                {errors.end_time && errors.end_time.type === "required" && (
                  <ValidateError />
                )}
              </div>
            </div>
        <div className="flex w-full gap-8 justify-between items-center mobile:flex-wrap">
         <p className="text-[14px] text-[#747474]">Availability is computed against your club booking system in real time</p>
          
            <div className="flex-1 flex w-full gap-4 mobile:flex-wrap ">
              <div className="flex-1 w-full mobile:min-w-[200px] ">
                <Controller
                  name="match_per_day"
                  control={control}
                  rules={{ required: false }}
                  render={({ field }) => (
                    <div className="flex flex-row gap-3   items-center pt-2">
                      <h3 className="text-primary dark:text-white text-lg  font-bold">
                        {inputs.player_can_play_one_match_per_day}
                      </h3>
                      <Toggle
                        isDisabled={!isAllow}
                        state={field.value || false}
                        onClick={() => {
                          setValue("match_per_day", !field.value);
                        }}
                        customClassName={"peer-checked:bg-primary"}
                      />
                    </div>
                  )}
                />
                {/* @ts-ignore */}
              </div>
            </div>
          
          <div className=" mobile:pb-2  ">
            <button
              className={cn(
                "flex gap-2 items-center bg-primary dark:bg-primaryYellow dark:text-primary dark:border-none py-4 px-4 rounded-full border border-main-1 text-[#CBDB2A] whitespace-nowrap w-fit text-[16px]",
                (!isAllow || !matchDuration) &&
                  "bg-[#f3f3f3] text-primary dark:text-white cursor-not-allowed"
              )}
              type="button"
              onClick={async (e) => {
                if(!matchDuration) return;
                e.preventDefault();
                if (isAllow || getValue("state") === "Draft") {
                  const checkFieldList = [
                    "start_date",
                    "end_date",
                    "start_time",
                    "end_time",
                    "match_duration",
                  ];
                  // Trigger validation for all fields

                  //@ts-ignore
                  const isValid = await trigger(checkFieldList);

                  // Dispatch action to add league info

                  // Log errors (this will now show the updated errors)

                  // Check if there are no errors
                  if (isValid && Object.keys(errors).length === 0) {
                    console.log(getValue());
                    const available_courts =
                      getValue().available_courts.length >= 0
                        ? getValue().available_courts
                        : Object.keys(getValue().available_courts);
                    setAvailableCourts({
                      ...getValue(),
                      event_id: param.id,
                      court_ids: getValue().court_ids.map(
                        (court: any) => court.id
                      ),
                      club_id: selectedClub,
                      selected_days:[],
                      available_courts:
                        getValue("state") === "Draft"
                          ? []
                          : getValue().available_courts.length >= 0
                          ? getValue().available_courts
                          : Object.keys(getValue().available_courts),
                    });
                    setCourts(getValue().court_ids);
                    setAvailableCourtsLoading(true);
                  }
                }
              }}
            >
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.25 16.25L20.75 20.75" stroke={(!isAllow || !matchDuration)?"#1E1850":"#CBDB2A"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18.75 9.75C18.75 4.77944 14.7206 0.75 9.75 0.75C4.77944 0.75 0.75 4.77944 0.75 9.75C0.75 14.7206 4.77944 18.75 9.75 18.75C14.7206 18.75 18.75 14.7206 18.75 9.75Z" stroke={(!isAllow || !matchDuration)?"#1E1850":"#CBDB2A"} stroke-width="1.5" stroke-linejoin="round"/>
</svg>

              Check courts availability
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ScheduleInfoV2;
